
$(() => {
    $('.tours__filter-select').selectize({
        // allowEmptyOption: true,
        // create: false,
        // onInitialize: function() {
        //     const selectize = this;
        //     console.log(selectize.getValue());
        //     // Устанавливаем пустое значение при инициализации
        //     selectize.setValue('');
        // },
        // onChange: function(value) {
        //     // Если значение пустое, сохраняем состояние placeholder
        //     if (!value) {
        //         this.clear();
        //     }
        // }
    });

    $('.tours__filter-selects').click(() => {
        $('.select2-container .select2-dropdown').addClass('tours__filter-selects');
    });

    if ($('.tours__filter-nav-item-1').hasClass('active')) {
        $('.tours__filter-selects-2').hide();
        $('.tours__filter-selects-3').hide();
    } else if ($('.tours__filter-nav-item-2').hasClass('active')) {
        $('.tours__filter-selects-1').hide();
        $('.tours__filter-selects-3').hide();
    } else {
        $('.tours__filter-selects-1').hide();
        $('.tours__filter-selects-2').hide();
    }

    $('.tours__filter-nav-item-1').click((e) => {
        e.preventDefault();
        $('.tours__filter-selects-2').hide();
        $('.tours__filter-selects-3').hide();
        $('.tours__filter-selects-1').show();
    });

    $('.tours__filter-nav-item-2').click((e) => {
        e.preventDefault();
        $('.tours__filter-selects-1').hide();
        $('.tours__filter-selects-3').hide();
        $('.tours__filter-selects-2').show();
    });

    $('.tours__filter-nav-item-3').click((e) => {
        e.preventDefault();
        $('.tours__filter-selects-1').hide();
        $('.tours__filter-selects-2').hide();
        $('.tours__filter-selects-3').show();
    });

    $('.tours__filter-nav-item').click(function () {
        $(this).closest('.tours__filter-nav').find('.tours__filter-nav-item').removeClass('active');
        $(this).addClass('active');
    });

    if ($('.tours__filter').length > 0) {
        class ToursFilter {
            constructor() {
                this._wrapper = $('.tours__filter');
                this._select = $(this._wrapper).find('.tours__filter-select');

                this._railwaysWrapper = $('#tours_list');

                this._route = $(this._wrapper).data('route');

                console.log(this._route);

                this._init();
            }

            _init() {
                this._select.on('change', this._handleSort.bind(this));
            }

            _handleSort(event) {
                event.preventDefault();
                const form = event.target.closest('form');

                let data = {};

                $(form).find('select').each((index, item) => {
                    if ($(item).val() != '0') {
                        data[item.name] = $(item).val();
                    }
                });

                // Формируем строку запроса
                const params = new URLSearchParams(data).toString();
                const newUrl = `${this._route}?${params}`;

                // Обновляем URL без перезагрузки страницы
                // history.pushState(null, '', newUrl);

                window.location.href = newUrl;

            }
        }

        new ToursFilter;
    }
});